// extracted by mini-css-extract-plugin
module.exports = {"headerInfo":"regForm_headerInfo__3l4jO","formGroup":"regForm_formGroup__1gNps","cover":"regForm_cover__3rWbJ"};